import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '@/store';
import {
  API_RESPONSE_STATUS,
} from '@/utils/constants';

Vue.use(VueRouter);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters['user/isAuthenticated']) {
    next();
  } else {
    const path = from?.fullPath || from?.path;
    const target = path === '/' ? '/menu' : path;
    next(target);
  }
};

const routes = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/choose_team',
    name: 'ChooseTeam',
    beforeEnter: ifNotAuthenticated,
    component: () => import('../views/ChooseTeam/ChooseTeam.vue'),
  },
  {
    path: '/link_outdated',
    name: 'LinkOutdated',
    component: () => import('../views/LinkOutdated/LinkOutdated.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    beforeEnter: ifNotAuthenticated,
    component: () => import('../views/Login/Login.vue'),
  },
  {
    path: '/menu',
    name: 'MenuList',
    component: () => import('../views/MenuList/MenuList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/menu/:id',
    name: 'Menu',
    component: () => import('../views/Menu/Menu.vue'),
  },
  {
    path: '/order_completed',
    name: 'OrderCompleted',
    component: () => import('../views/OrderCompleted/OrderCompleted.vue'),
    props: true,
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () => import('../views/Orders/Orders.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/reimbursement_code',
    name: 'ReimbursementCode',
    component: () => import('../views/ReimbursementCode/ReimbursementCode.vue'),
  },
  {
    path: '/reset_password',
    name: 'SetPassword',
    beforeEnter: ifNotAuthenticated,
    component: () => import('../views/ResetPassword/ResetPassword.vue'),
  },
  {
    path: '/set_password',
    name: 'SetPassword',
    beforeEnter: ifNotAuthenticated,
    component: () => import('../views/SetPassword/SetPassword.vue'),
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('../views/User/User.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/verify_email',
    name: 'SendVerifyEmail',
    beforeEnter: ifNotAuthenticated,
    component: () => import('../views/SendVerifyEmail/SendVerifyEmail.vue'),
  },
  {
    path: '/oauth/line/callback',
    name: 'LineCallback',
    component: () => import('../views/LineCallback/LineCallback.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `/${API_RESPONSE_STATUS.NOT_WORKING}`,
    name: 'NotWorking',
    component: () => import('../views/NotWorking/NotWorking.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(({ meta }) => meta.requiresAuth)) {
    const isAuthenticated = store.getters['user/isAuthenticated'];
    if (!isAuthenticated) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

export default router;
